

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface MedicineParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface Medicine {
    snoMedCode?:string;
    snomedCode?: string;
    snomedDisplay?: string;
    id?: any;
    tenantId: any;
    branchId: any;
    name: string;
    nameLanguageValue?:string;
    genericId:any;
    medicineCategoryId?:any;
    manufacturerId?:any;
    medicineType:any;
    price:any;
    genericName?:any;
    medManufacturer?:any;
    medicineCategory?:any;
    unitId:any;
    units?: any;
    rack:any;
    gtinCode:any;
    hsnCode:any;
    gst:any;
    minQty:any;
    maxQty:any;
    isVaccine:string;
    archiveFlag:string;
    warehouseId:number;
    discrequired:string;
    disctype:string;
    discpercentage:any;
    discamount:any;
    description:string;
    mappingAttribute?:string;
    medicinePriceSettingsDet?:Record<string,any> |  null;
    outsideMedicineFlag?:boolean;
    pharmType?: boolean;

    parameters?: MedicineParameter[];
    links?: any;
    strength?: string;
    darno?: string;
    medicineCode?:string;
    medicineStrength?:number;
    newGst?:any;
    oldGst?:any;
    taxOtherCountryPatients?:any;

    nphiesCode?: any ;
    nphiesURL?: any ;
    sfdaCode?: any ;
    brandPriority?: boolean ;
    highAlert?: boolean ;
    nphiesDescription?: any ;
    isIDF?:string;
    nphiesCategory?:number;
    isHighCost:boolean;
    nphiesDisplayValue?:string;
    variationMstId?:any
    variationMst?:any
    countryCode?:any
    pharmacistReviewRequired?:boolean;
    storageShelf?: any; // Karthi
    createdBy?: number; // Karthi
    createdDate?: any; // Karthi
    updatedBy?: number; // Karthi
    updatedDate?: any; // Karthi
}


export abstract class MedicineData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<Medicine[]>;
    abstract get_by_id(url: string): Observable<any[]>;
    abstract create(url: string, data: Medicine): Observable<Medicine[]>;
    abstract update(url: string, data: Medicine): Observable<Medicine>;
    abstract delete(url: string): Observable<any>;
    abstract searchList(url:string,data:any): Observable<any>;
    abstract postData(url: string, data: any[]): Observable<any>;
    abstract medicinePresctiptionGet(url: string): Observable<any[]>;

    abstract gstUpdate(url:string,data:any): Observable<any>;

}
